import type { MessageKey } from '~/i18n/messages.ts';

/**
 * The notes the shop itself writes on an order's timeline, translated for display.
 *
 * Stored as English sentences, which is what older orders hold, so they are matched here rather
 * than changed at the source. A note staff typed by hand is shown exactly as written.
 */
const SYSTEM_NOTES: Record<string, MessageKey> = {
  'Order placed.': 'orderNote.placed',
  'Payment received.': 'orderNote.paid',
  'Payment declined.': 'orderNote.declined',
  'Unpaid past the hold period.': 'orderNote.expired',
  'Cancelled by the customer.': 'orderNote.cancelledByCustomer',
};

const CUSTOMER_REASON = 'Cancelled by the customer: ';

export function orderNote(note: string, t: (key: MessageKey, values?: Record<string, string>) => string): string {
  const key = SYSTEM_NOTES[note];

  if (key) {
    return t(key);
  }

  if (note.startsWith(CUSTOMER_REASON)) {
    return t('orderNote.cancelledByCustomerBecause', { reason: note.slice(CUSTOMER_REASON.length) });
  }

  return note;
}
